import AppFeatureEditor from '../AppFeatureEditor'

class ParcelFeatureEditor extends AppFeatureEditor {}

export default ParcelFeatureEditor
